import { render, staticRenderFns } from "./exportTxt.vue?vue&type=template&id=3fa52bef&scoped=true&"
import script from "./exportTxt.vue?vue&type=script&lang=js&"
export * from "./exportTxt.vue?vue&type=script&lang=js&"
import style0 from "./exportTxt.vue?vue&type=style&index=0&id=3fa52bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa52bef",
  null
  
)

export default component.exports